module.exports = __webpack_public_path__ + "static/media/Event-Carousels-FnB.54b1d0a8.jpg";